var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "ringe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 17.2072C21.0667 17.2072 19.3333 16.942 17.8667 16.4116C17.3333 16.279 16.9333 16.4116 16.5333 16.6768L13.6 19.5939C9.86667 17.7376 6.8 14.5552 4.8 10.8425L7.73333 7.92541C8.13333 7.52762 8.26667 6.99724 8 6.59945C7.46667 5.14088 7.2 3.54972 7.2 1.82597C7.2 1.03039 6.66667 0.5 5.86667 0.5H1.33333C0.533333 0.632597 0 1.16298 0 1.95856C0 14.4227 10.1333 24.5 22.6667 24.5C23.3333 24.5 24 23.837 24 23.174V18.5331C24 17.8702 23.3333 17.2072 22.6667 17.2072ZM12 0.632597V13.8923L16 9.91436H24V0.632597H12Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.83d007f7.svg";
export { ForwardRef as ReactComponent };